<template>
  <div id="profilePage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="پروفایل"></ActionBar>
    <div class="row container mx-auto no-gutters p-0 mt-2">

      <div class="col-12  rounded-b-lg header-rounded bg-white card-shadow">
        <div class="third-background header-rounded mb-3 white--text p-2">اطلاعات پایه دانش آموز</div>
        <v-form ref="form" class=" row mx-1">
          <div class="col-12 pb-4 text-center light-gray-bottom-border">
            <div class="avatar-wrapper" id="avatarWrapper">
              <img class="profile-pic img-fluid" src=""/>
              <div class="upload-button" @click="changeAvatar()">
              </div>
              <input id="ImageFileUrlLogo" accept="image/*" class="file-upload" name="ImageFileUrlLogo" type="file"/>
            </div>
          </div>
          <div class="profile-field row mx-1 pt-4">
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="font-weight-bold">نام و نام خانوادگی: </span>
              <span> {{ studentName }} {{ studentFamily }}</span>
            </div>
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="font-weight-bold">شماره دانش آموزی: </span><span>
            {{ studentNo }}</span>
            </div>
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
                class="font-weight-bold">کد ملی: </span><span>{{
                studentNationalCode
              }}</span>
            </div>
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
                class="font-weight-bold"> تاریخ تولد: </span>
              <span> {{ studentBirthDate }}</span></div>
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
                class="font-weight-bold">  جنسیت: </span><span>{{ studentGender }} </span>
            </div>
            <!--          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"> نام کاربری: <span>{{ studentUserName }}</span>-->
            <!--          </div>-->
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6 "><span class="font-weight-bold"> تاریخ ثبت نام: </span>
              <span>{{ studentRegisterDate }}</span></div>
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
                class="mt-1 font-weight-bold">رمز عبور:</span>
              <v-text-field
                  v-model="studentPassword"
                  class="mr-1 input-border gray-bg-input"
                  dense
                  solo
                  type="number">
              </v-text-field>
            </div>
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
                class="mt-1 font-weight-bold">تلفن همراه دانش آموز:</span>
              <v-text-field
                  v-model="studentMobile"
                  :rules="phoneNumberRules"
                  class="input-border gray-bg-input "
                  dense
                  solo
                  type="number">
              </v-text-field>
            </div>
            <!--          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1">تلفن ثابت:</span>-->
            <!--            <v-text-field-->
            <!--                v-model="studentStaticPhone"-->
            <!--                class="input-border gray-bg-input"-->
            <!--                dense-->
            <!--                solo-->
            <!--                type="number">-->
            <!--            </v-text-field>-->
            <!--          </div>-->
            <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
                class="mt-1 font-weight-bold">ایمیل:</span>
              <v-text-field
                  v-model="studentEmail"
                  :rules="emailRules"
                  class="input-border gray-bg-input"
                  dense
                  solo
                  type="email">
              </v-text-field>
            </div>

            <div class="light-gray-bottom-border col-12 col-md-6 "><span class="font-weight-bold"> آدرس:</span>
              <v-textarea
                  v-model="studentAddress"
                  class="input-border gray-bg-input "
                  dense
                  solo
                  type="text">
              </v-textarea>
            </div>

          </div>
        </v-form>
      </div>
      <div class="col-12 rounded-b-lg header-rounded bg-white card-shadow my-3">
        <div class="third-background header-rounded mb-3 white--text p-2"><span>اطلاعات پدر دانش آموز</span></div>
        <div class="profile-field row mx-1">
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="font-weight-bold"> نام و نام خانوادگی پدر: </span>
            <span>{{ fatherName }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
              class="font-weight-bold">  کد ملی پدر: </span> <span>
            {{ fatherNationalCode }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
              class="font-weight-bold">تحصیلات پدر: </span>
            <span>{{ fatherEducation }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-6 col-sm-6"><span class="font-weight-bold">شغل پدر: </span><span>{{
              fatherJob
            }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-6 col-sm-6"><span
              class="font-weight-bold">نام کاربری پدر: </span><span>
            {{ fatherUserName }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1 font-weight-bold">رمز عبور پدر:</span>
            <v-text-field
                v-model="fatherPassword"
                class="mr-1 input-border gray-bg-input"
                dense
                hide-details
                solo
                type="number">
            </v-text-field>
          </div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1 font-weight-bold">تلفن محل کار پدر:</span>
            <v-text-field
                v-model="fatherWorkPhone"
                class="input-border gray-bg-input "
                dense
                hide-details
                solo
                type="number">
            </v-text-field>
          </div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1 font-weight-bold">تلفن همراه پدر:</span>
            <v-text-field
                v-model="fatherMobile"
                :rules="phoneNumberRules"
                class="input-border gray-bg-input "
                dense
                solo
                type="number">
            </v-text-field>
          </div>
        </div>
      </div>
      <div class="col-12 rounded-b-lg header-rounded bg-white card-shadow">
        <div class="third-background header-rounded mb-3 white--text p-2"><span> اطلاعات مادر دانش آموز</span></div>
        <div class="profile-field row mx-1">
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="font-weight-bold">نام و نام خانوادگی مادر: </span>
            <span>{{ motherName }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
              class="font-weight-bold">کد ملی مادر : </span> <span>
            {{ motherNationalCode }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
              class="font-weight-bold"> تحصیلات مادر: </span><span>
            {{ motherEducation }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-6 col-sm-6"><span
              class="font-weight-bold"> شغل مادر: </span> <span>{{ motherJob }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-6 col-sm-6"><span
              class="font-weight-bold">نام کاربری مادر: </span> <span>
            {{ motherUserName }}</span></div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1 font-weight-bold">رمز عبور مادر:</span>
            <v-text-field
                v-model="motherPassword"
                class="mr-1 input-border gray-bg-input"
                dense
                hide-details
                solo
                type="number">
            </v-text-field>
          </div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1 font-weight-bold">تلفن محل کار مادر:</span>
            <v-text-field
                v-model="motherWorkPhone"
                class="input-border gray-bg-input "
                dense
                hide-details
                solo
                type="number">
            </v-text-field>
          </div>
          <div class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span class="mt-1 font-weight-bold">تلفن همراه مادر:</span>
            <v-text-field
                v-model="motherMobile"
                :rules="phoneNumberRules"
                class="input-border gray-bg-input "
                dense
                solo
                type="number">
            </v-text-field>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center col-12 mt-5">
      <v-btn class="gradient-btn" rounded @click="editProfile">
        ویرایش اطلاعات
      </v-btn>
    </div>
    <FooterMenu/>
    <v-dialog
        v-model="showResultDialog"
        persistent
        hide-overlay
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";
import $ from 'jquery'

export default {
  name: "Profile",
  metaInfo: {
    title: 'مسیربرتر-پروفایل'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: '',
    studentID: null,
    studentAddress: null,
    studentRegisterDate: null,
    studentEmail: null,
    studentStaticPhone: null,
    studentMobile: '',
    studentPassword: null,
    studentName: null,
    studentNo: null,
    studentNationalCode: null,
    studentBirthDate: null,
    studentGender: null,
    studentUserName: null,
    studentFamily: null,
    fatherPassword: null,
    fatherWorkPhone: null,
    fatherMobile: '',
    fatherName: null,
    fatherNationalCode: null,
    fatherEducation: null,
    fatherJob: null,
    fatherUserName: null,
    motherPassword: null,
    motherWorkPhone: null,
    motherMobile: '',
    motherName: null,
    motherNationalCode: null,
    motherEducation: null,
    motherJob: null,
    motherUserName: null,
    gender: ['', 'مرد', 'زن'],
    typeEducation: ['', 'دیپلم', 'کااردانی', 'کارشناسی', 'کارشناسی ارشد', 'دکتری', 'بی سواد'],
    phoneNumberRules: [
      v => !!v || 'شماره موبایل اجباری است',
      value => (value &&value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    emailRules: [
      v => !!v,
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(v) || 'ایمیل نامعتبر'
      }
    ],
    studentProfileID: null,
    fatherEdu: null,
    motherEdu: null,
    appUserId: null,
    schoolId: null,
    classRoomId: null,
    fileUrl: null,
  }),
  mounted() {
    _this = this

    $(".upload-button").on('click', function () {
      $(".file-upload").click();
    });
    this.showLoaderDialog = true
    this.getProfileData()
    this.getIndividualData()
  },

  methods: {
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    },
    changeAvatar() {
      this.fileUrl = null;
      let readURL = function (input) {
        let reader = new FileReader();
        if (input.files && input.files[0]) {
          reader.onload = function (e) {
            document.getElementById('avatarWrapper').style.backgroundImage ="url("+e.target.result+")"

            // $('.profile-pic').attr('src', e.target.result);
          }
          reader.readAsDataURL(input.files[0]);
        }
      }
      $(".file-upload").on('change', function () {
        readURL(this);
      });
    },
    getProfileData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "MyProfile/StudentProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)


            _this.studentAddress = json.Address;
            _this.studentNo = json.StudentNumber;
            _this.studentBirthDate = _this.$convertDate(json.BirhDate);
            _this.studentRegisterDate = _this.$convertDate(json.RegistrationDate);
            _this.studentGender = _this.gender[json.TypeSex];
            const reg = new RegExp(/^\d+$/)

            _this.fatherMobile = reg.test(json.FatherMobile) ?  json.FatherMobile : json.FatherUserName;
            _this.fatherName = json.FatherName;
            _this.fatherNationalCode = json.FatherNationalCole;
            _this.fatherEducation = _this.typeEducation[json.FatherEducation];
            _this.motherEducation = _this.typeEducation[json.MotherEducation];
            _this.fatherJob = json.FatherJob;
            _this.fatherWorkPhone = json.FatherWorkPhone;
            _this.fatherUserName = json.FatherUserName;
            _this.fatherPassword = json.FatherPassword;
            _this.motherJob = json.MotherJob;
            _this.motherWorkPhone = json.MotherWorkPhone;
            _this.motherNationalCode = json.MotherNationalCole;
            _this.motherUserName = json.MotherUserName;
            _this.motherPassword = json.MotherPassword;
            _this.motherMobile = json.MotherMobile;
            _this.motherName = json.MotherName;
            _this.studentProfileID = json.StudentProfileID;
            _this.studentTypeSex = json.TypeSex;
            _this.fatherEdu = json.FatherEducation
            _this.motherEdu = json.MotherEducation
            _this.appUserId = json.AppUserID
            _this.classRoomId = json.ClassRoomID
            _this.schoolId = json.SchoolID
            _this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getIndividualData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "MyProfile/Individual", requestOptions)
          .then(response => response.text())
          .then(result => {

            let json = (JSON.parse(result)).model;

            _this.studentName = json.Name
            _this.studentFamily = json.Family
            _this.studentNationalCode = json.NationalCode === null ? null : json.NationalCode
            _this.studentUserName = json.UserName
            _this.studentMobile = json.PhoneNumber
            _this.studentPassword = json.Password
            _this.studentEmail = (json.Email)
            _this.fileUrl = json.FileUrl
            _this.$setUserLogo(json.FileUrl);
            if (json.FileUrl !== null) {
              document.getElementById('avatarWrapper').style.backgroundImage ="url("+json.FileUrl+")"
              // $('.profile-pic').attr('src', this.$replaceHttps(json.FileUrl + "?q="+ Date.now()));
            }else {
              $('.profile-pic').attr('src', this.getImgUrl('logo.svg'));
            }

            _this.studentID = json.ID
          })
          .catch(error => console.log('error', error));
    },
    editProfile() {
      // this.$refs.form.validate()
      // if (this.$refs.form.validate()) {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", _this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("ID", _this.studentID);
        formdata.append("UserName", _this.studentUserName);
        formdata.append("Email", _this.studentEmail);
        formdata.append("Password", _this.studentPassword);
        formdata.append("ConfirmPassword", _this.studentPassword);
        formdata.append("Name", _this.studentName);
        formdata.append("Family", _this.studentFamily);
        // formdata.append("NationalCode", _this.studentNationalCode);
        formdata.append("TypeRole", "5");
        if (this.fileUrl !== null) {
          formdata.append("FileUrl", this.fileUrl);
        } else {
          formdata.append("ImageFileUrl", document.getElementById('ImageFileUrlLogo').files[0]);
        }
        formdata.append("PhoneNumber", _this.studentMobile);
        formdata.append("IsActive", "true");
        formdata.append("VeriyMobileCode", "");
        formdata.append("VeriyEmailCode", "");
        formdata.append("SmsNotification", "true");
        formdata.append("PushNotification", "true");
        formdata.append("EmailNotification", "true");

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "MyProfile/Individual", requestOptions)
            .then(result => {
              if (result.status === 200) {
                _this.editStudent()
              } else {
                result.text().then(text => {

                  _this.showLoaderDialog = false;
                  _this.showResultDialog = true;
                  _this.dialogResult = JSON.parse(text)
                })
              }
            })
            .catch(error => console.log('error', error));
      // }
    },
    editStudent() {
      this.showLoaderDialog = true
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StudentProfileID", this.studentProfileID);
      urlencoded.append("TypeSex", this.studentTypeSex);
      urlencoded.append("BirhDate", this.studentBirthDate);
      urlencoded.append("TypeStateProfile", "1");
      urlencoded.append("Address", this.studentAddress);
      urlencoded.append("StudentNumber", this.studentNo);
      urlencoded.append("FatherMobile", this.fatherMobile);
      urlencoded.append("FatherName", this.fatherName);
      urlencoded.append("FatherEducation", this.fatherEdu);
      urlencoded.append("FatherJob", this.fatherJob);
      urlencoded.append("FatherWorkPhone", this.fatherWorkPhone);
      urlencoded.append("FatherNationalCole", this.fatherNationalCode);
      urlencoded.append("FatherUserName", this.fatherUserName);
      urlencoded.append("FatherPassword", this.fatherPassword);
      urlencoded.append("MotherMobile", this.motherMobile);
      urlencoded.append("MotherName", this.motherName);
      urlencoded.append("MotherEducation", this.motherEdu);
      urlencoded.append("MotherJob", this.motherJob);
      urlencoded.append("MotherWorkPhone", this.motherWorkPhone);
      urlencoded.append("MotherNationalCole", this.motherNationalCode);
      urlencoded.append("MotherUserName", this.motherUserName);
      urlencoded.append("MotherPassword", this.motherPassword);
      urlencoded.append("AppUserID", this.appUserId);
      urlencoded.append("SchoolID", this.schoolId);
      urlencoded.append("ClassRoomID", this.classRoomId);
      urlencoded.append("RegistrationDate", this.studentRegisterDate);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "MyProfile/StudentProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.showResultDialog = true;
            _this.dialogResult = result
            this.getIndividualData()

          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>